<template>
  <div 
  @mouseover="hasHover = true"
  @mouseout="hasHover =false"
  :class="[{'crx-input': !labelMode}, {'disabled': disabled}, {'borderless': hasProgressSlot}, {'label-mode': labelMode}, {'mt-4': label}]">

    <label
    :class="['crx-label', {'primary--text crx-label--active': localFocussed}, {'crx-label--active': localQuantity.toString().length > 0}]">
      {{ label }}
    </label>

    <div class="nowrap-hflex">

      <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="red"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            DEBUG
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <div>computedRealValue: {{ computedRealValue }}</div>
            <div>quantity: {{ quantity }}</div>
          </div>
        </v-card>
      </v-menu>

      <!-- input -->
      <div v-if="labelMode">
        <!-- 
          THE OLD WAY - you can most likely deprecate this
          {{ showLabelUnrounded ? localQuantity : roundedFinalQuantity }} {{ metricLabel }} 
          -->
        {{ Number(showLabelUnrounded ? localQuantity : roundedFinalQuantity).toLocaleString() }} {{ metricLabel }}
      </div>

      <template v-else>

        <input
        v-model.number="localQuantity"
        spellcheck="false"
        ref="input"
        :disabled="disabled"
        @keydown="onKeyDown"
        @focus="onFocus"
        @blur="onBlur"
        />

        <!-- menu -->
        <v-menu
        :close-on-content-click="false"
        v-model="menu"
        offset-y
        :disabled="disabled"
        min-width="200"
        transition="scale-transition"
        right
        >

          <!-- activator -->
          <!-- 
          <template v-slot:activator="{ on }">
            <span
            v-on="on"
            :class="['metric-label ml-1 pr-2', { 'color1--text' : menu}]"> 
              {{ metricLabel }} 
              <v-icon
              color="text"
              >
                mdi-chevron-down
              </v-icon>
            </span>
          </template>
          -->
          <template v-slot:activator="{ on }">
            <v-btn
            v-on="on"
            text
            small
            :disabled="disabled"
            :class="['font-weight-regular pa-0']"> 
              {{ metricLabel }} 
              <v-icon
              color="text"
              small
              >
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </template>

          <!-- dropdown -->
          <v-card>
            <div class="label pa-2 font-weight-bold">Metric system</div>

            <div class="text-center">
              <span class="title color1--text">
                {{ localQuantity }} 
              </span>
              <span class="caption label">
                {{ metricLabelFull }}
              </span>
            </div>

            <v-select
              v-model="popupMetricSystemCode"
              class="ma-2 input-slot-thin-border caption"
              :items="metricSystems"
              dense
              hide-details
              solo
            ></v-select>
              <v-layout class="pa-2" justify-center>
                <v-btn-toggle v-model="popupMetricSystemCode" class="flexx-item" mandatory>
                  <v-btn small value="si">
                    SI
                  </v-btn>
                  <v-btn small value="bi">
                    BI
                  </v-btn>
                  <v-btn small value="us">
                    US
                  </v-btn>
                </v-btn-toggle>
              </v-layout>

              <v-layout class="pl-2 pr-2">
                <v-btn-toggle
                v-if="localAllowedMetrics.length > 1"
                v-model="popupMetricCode" 
                class="flex-item" mandatory>
                  <v-btn v-for="allowedMetric in localAllowedMetrics" :key="allowedMetric" :value="allowedMetric" small>
                    {{ allowedMetric }}
                  </v-btn>
                </v-btn-toggle>
              </v-layout>

              <v-list>
                <v-list-item v-for="(item, index) in listedMetrics" :key="index" @click="localSid = item.sid">
                  <v-list-item-title :class="[{ 'color1--text' : item == selectedMetric}]">{{ item.name }}</v-list-item-title>
                  <v-chip outlined :class="[{ 'color1--text' : item == selectedMetric}]">
                    {{ item.symbol }}
                  </v-chip>
                </v-list-item>
              </v-list>

          </v-card>
        </v-menu>

      </template>

    </div>
    
    <slot name="progress"></slot>
  </div>
</template>

<script>
/* You can initialize the selector in two ways
{quantity, sid}
{quantity, metric_definition} OR {realValue. metric_definition}
*/
import {BigNumber} from 'bignumber.js'

export default {
  props: {
    allowedMetrics: {
      // default: () => ['units', 'vol', 'mass', 'len']
      default: () => []
    },
    quantity: {
      default: 0,
      type: [String, Number]
    },
    sid: {
      default: null,
      type: String
    },
    prefferedSid: {
      default: null,
      type: String
    },
    metric_definition: { // {metric, units, mass, volume, length}
      default: null
    },
    realValue: {
      default: 0
    },
    metric: {
      default: null
    },
    borderless: {
      default: null
    },
    focussed: {
      default: false
    },
    label: {
      default: ''
    },
    labelMode: {
      type: Boolean,
      default: false
    },
    alwaysScale: { // e.g. change ml to l or kl always
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    preventScaleOnCreated: { // prevents the on create auto scaling
      type: Boolean,
      default: false
    },
    showLabelUnrounded: { // dont round the label to 2 decimal places
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menu: false,
      hasHover: false,
      selectedMetric: this.$crx.metrics.metricTable[0],
      metricSystems: [
        {
          text: 'SI metric units',
          value: 'si'
        },
        {
          text: 'British Imperial units',
          value: 'bi'
        },
        {
          text: 'US Customary units',
          value: 'us'
        }
      ],
      popupMetricSystemCode: 'si',
      popupMetricCode: 'units',
      localAllowedMetrics: this.allowedMetrics,
      localSid: this.sid,
      localQuantity: this.quantity,
      localMetric: this.metric,
      localFocussed: false
    }
  },
  computed: {
    metricLabelFull () {
      var metric = this.$crx.metrics.getMetricRowFromSid(this.localSid).name
      if (metric === 'units' && this.localQuantity === 1) {
        return 'unit'
      }
      return metric
    },
    metricLabel () {
      var metric = this.$crx.metrics.getMetricRowFromSid(this.localSid).symbol
      if (metric === 'units' && this.localQuantity === 1) {
        return 'unit'
      }
      return metric
    },
    listedMetrics () {
      var comb = this.popupMetricSystemCode + '-' + this.popupMetricCode
      var sorted = this.$crx.metrics.metricTable.filter(item => {
        return item.sid.startsWith(comb)
      })
      return sorted
    },
    computedRealValue: {
      get () {
        if (this.localSid) {
          var realVal = this.convertToBaseUnits(this.localQuantity, this.localSid)
          if (isNaN(realVal)) {
            // as is the case when you clear out the input so localQuantity = an empty string or null
            realVal = 0
          }
          return realVal
        }
      },
      set (nv) {
      }
    },
    roundedFinalQuantity () {
      return Math.round(this.localQuantity * 100) / 100
    },
    hasProgressSlot () {
      return !!this.$slots['progress']
    }
  },
  methods: {
    onKeyDown () {
      this.$emit('onKeyDown')
    },
    onFocus (e) {
      this.localFocussed = true
      e.target.select()
    },
    onBlur (event) {
      this.localFocussed = false
      this.$emit('blur', event)
    },
    convertToBaseUnits (quantity, sid) {
      if (this.metric_definition) {
        return this.$crx.metrics.convertToNative(quantity, sid, this.metric_definition)
      } else {
        return this.$crx.metrics.convertToBaseUnits(quantity, sid)
      }
    },
    updateMenu () { // item = the metric object row with all details
      var item = this.$crx.metrics.getMetricRowFromSid(this.localSid)
      this.selectedMetric = item
      var splitSid = this.localSid.split('-')
      this.popupMetricSystemCode = splitSid[0]
      this.popupMetricCode = splitSid[1]
      this.menu = false
    },
    changeToSID (newSID) {
      if (newSID) {
        // if localSid is already in the same metric e.g. vol
        // this allows changing metric even if no inventory definition is supplied
        if (this.localSid.split('-')[1] === newSID.split('-')[1]) {
          var nvRatio = this.$crx.metrics.getMetricRowFromSid(newSID).ratio
          var currentRatio = this.$crx.metrics.getMetricRowFromSid(this.localSid).ratio
          this.localQuantity = new BigNumber(new BigNumber(this.localQuantity).times(currentRatio)).div(nvRatio).toNumber()
          this.localSid = newSID
        } else if (this.metric_definition) {
          var ratio = this.$crx.metrics.getConversionRatioFromSidsOld(this.localSid, newSID, this.metric_definition)
          if (ratio) {
            // convert to a sibling metrics native units
            this.localQuantity = new BigNumber(this.localQuantity).times(ratio)
            nvRatio = this.$crx.metrics.getMetricRowFromSid(newSID).ratio
            this.localQuantity = this.localQuantity.div(nvRatio).toNumber()
            this.localSid = newSID
          }
        }
      } else {
        // null = set to defualts
        var metricInt = this.$crx.metrics.sidToInt(this.localSid)
        if (this.metric_definition) {
          metricInt = this.metric_definition.metric
        }
        var hmetric = this.$crx.metrics.humanizeDBMetric(this.computedRealValue, metricInt)
        this.localQuantity = hmetric.quantity
        this.localSid = hmetric.sid
      }
    },
    rescale () {
      var hmetric = this.$crx.metrics.humanizeDBMetric(this.realValue, this.localMetric)
      this.localSid = hmetric.sid
      this.localQuantity = hmetric.quantity
    },
    recalculateAllowedMetrics () {
      if (this.metric_definition) {
        this.localAllowedMetrics = []
        switch (this.metric_definition.metric) {
          case 0:
            this.localAllowedMetrics.push('units')
            break
          case 1:
            this.localAllowedMetrics.push('vol')
            break
          case 2:
            this.localAllowedMetrics.push('mass')
            break
          case 3:
            this.localAllowedMetrics.push('len')
            break
        }
        if (this.metric_definition.volume > 0) {
          this.localAllowedMetrics.push('vol')
        }
        if (this.metric_definition.mass > 0) {
          this.localAllowedMetrics.push('mass')
        }
        this.localAllowedMetrics = this.$codash.arrayUnique(this.localAllowedMetrics)
      } else {
        this.localAllowedMetrics = []
        switch (this.localSid.split('-')[1]) {
          case 0:
            this.localAllowedMetrics.push('units')
            break
          case 1:
            this.localAllowedMetrics.push('vol')
            break
          case 2:
            this.localAllowedMetrics.push('mass')
            break
          case 3:
            this.localAllowedMetrics.push('len')
            break
        }
      }
    }
  },
  watch: {
    // props
    prefferedSid: {
      handler (nv, ov) {
        this.changeToSID(nv)
      }
    },
    sid: {
      // immediate: true,
      handler (nv, ov) {
        this.localSid = nv
      }
    },
    realValue: {
      handler (nv, ov) {
        // prevent re-adding zero on backspace
        if (this.localQuantity === '' && nv === 0) {
          console.log('returning from block 1')
          return
        }
        // continue
        let ratio = this.convertToBaseUnits(1, this.localSid)
        var newValue = new BigNumber(nv).dividedBy(ratio)
        if (this.localQuantity === '') {
          // this occurs when for example you manually clear the selector (so it equals '') and then try to automatically set it again. without this itll stay blank
          this.localQuantity = newValue
        }
        if (!isNaN(newValue)) { // if its a number
          if (!this.localFocussed) {
            var dif = new BigNumber(newValue).minus(this.localQuantity).abs()
            if (dif.isGreaterThan(0.000001)) {
              this.localQuantity = newValue
            } else {
              // console.log('difference is smaller than 0.000001')
            }
          }
        }
        // upscale?
        /* if (this.alwaysScale) {
          this.rescale()
        } */
        if (!this.localFocussed && !this.prefferedSid) {
          this.rescale()
        }
      }
    },
    quantity: {
      handler (nv, ov) {
        this.localQuantity = nv
      }
    },
    /*
    'definition.id': {
      handler (nv, ov) {
        if (!nv) { // if def set to null
          this.localSid = 'si-units-units'
        } else {
          this.localSid = this.$crx.metrics.getBaseMetricFromDBint(this.definition.metric).sid
        }
        this.recalculateAllowedMetrics()
        this.updateMenu()
      }
    },
    */
    allowedMetrics (val) {
      this.localAllowedMetrics = val
    },
    // local
    localSid: function (nv) {
      this.updateMenu()
      this.$emit('update:sid', nv)
      this.localMetric = this.$crx.metrics.sidToInt(nv)
    },
    localQuantity (nv, ov) {
      this.$emit('update:quantity', nv)
    },
    localMetric (nv) {
      this.$emit('update:metric', nv)
    },
    computedRealValue (nv) {
      // cast realValue || 0 incase its null
      var dif = new BigNumber(nv).minus(this.realValue || 0).abs()
      if (dif.isGreaterThan(0.00000001)) {
        this.$emit('update:realValue', nv)
      } else {
        // console.log('skipping emit as diff is negligible')
      }
    },
    localFocussed (nv) {
      this.$emit('update:focussed', nv)
    }
  },
  created () {
    if (this.realValue > this.quantity) {
      this.localQuantity = this.realValue
    }

    if (!this.sid && this.metric_definition) {
      this.localSid = this.$crx.metrics.getBaseMetricFromDBint(this.metric_definition.metric).sid
    } else if (!this.sid && !this.metric_definition) {
      // like in delivery rows when the row is empty (item has not been selected yet)
      this.localSid = 'si-units-units'
    }

    this.localMetric = this.$crx.metrics.sidToInt(this.localSid)
    if (!this.sid) {
      this.changeToSID(this.prefferedSid)
    }
    this.recalculateAllowedMetrics()
    this.updateMenu()
    // disabled for now, this was the prvious setting, but, why not always scale? and then have a setting for the non default behaviour, 'absolute'?
    /* if (this.alwaysScale) {
      this.rescale()
    } */
    if (!this.preventScaleOnCreated) {
      this.rescale()
    }
    // emit initial values, this doesnt work when placed in immediate watchers
    this.$emit('update:sid', this.localSid)
  }
}
</script>

<style scoped>
.label-mode {
  margin-top: 0px;
  width: auto;
  display: inline-flex;
}
/* hide bottom border */
.label-mode::before {
  border: none;
}
.v-btn-toggle--selected {
  box-shadow: none;
}
.theme--light .v-btn-toggle {
  background: none;
}
.nowrap-hflex {
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
}
.text-align-right {
  text-align: right;
}

.metric-label {
  white-space: nowrap;
  display: flex;
  align-items: flex-end;
}

.flex-item {
  flex: 1;
}

/* Hide HTML5 Up and Down arrows. */
input[type="number"]::-webkit-outer-spin-button, input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
 
input[type="number"] {
  -moz-appearance: textfield;
}

/* BORDER */
.border-bottom {
  border-bottom: 1px solid rgba(0,0,0,0.1);
}

.crx-cell .border-bottom {
  border: none;
}
</style>
